export default {
    namespaced: true,

    state: () => ({
        debug: {},
    }),

    mutations: {
        STORE_DEBUG_DATA(state, debug) {
            state.debug = debug
        },
    },

    actions: {},
};
